export const SET_CONTACT = "SET_CONTACT";
export const SET_CONTACTS = "SET_CONTACTS";
export const SET_NEW_CONTACTS = "SET_NEW_CONTACTS";
export const ADD_CONTACT = "ADD_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const SET_UNSUBSCRIBE_GET_CONTACT = "SET_UNSUBSCRIBE_GET_CONTACT";
